<template>
  <vs-table :data="data">
    <template slot="header">
      
      <!-- <vs-button
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-archive"
        class="mx-2"
        @click="downloadDocuments(data[0].vendor_id)"
        :tooltip="$t('downloadDocuments')"
        >
        {{ $t('downloadDocuments') | capitalize }}
      </vs-button> -->
      <h3 class="px-2">
        {{ title | upperCase }}
      </h3>
      <div class="con-input-search vs-table--search">
        <input
          class="input-search vs-table--search-input"
          type="text"
          v-model="text"
          @keypress.enter="search"
        />
        <vs-icon icon="search"></vs-icon>
      </div>
    </template>
    <template slot="thead">
      <vs-th>
        {{ $t('document') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('frequency') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('start_date') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('end_date') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('automatic') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('status') | capitalize }}
      </vs-th>
      <th class="qb-sticky"></th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td style="max-width: 400px;">
          {{ data[i].document_name | capitalize }}
        </vs-td>
        <vs-td>
          {{ data[i].frequency_name | upperCase }}
        </vs-td>
        <vs-td>
          {{ data[i].start_date != null ? formatDate(data[i].start_date) : '' }}
        </vs-td>
        <vs-td>
          {{  data[i].end_date != null ? formatDate(data[i].end_date) : ''  }}
        </vs-td>
        <vs-td >
          <vs-chip :color="'#28C76F'" v-if="data[i].active === '1'">
            {{ $t('enabled') | upperCase }}
          </vs-chip>
          <vs-chip :color="'#BC1300'" v-else>
            {{ $t('disabled') | upperCase }}
          </vs-chip>
        </vs-td>
        <vs-td>
          <vs-chip :color="data[i].status_color" v-if="data[i].documentation_id != null">
            {{  $t(data[i].status_name) | upperCase }}
          </vs-chip>
          <vs-chip v-else>
            {{  $t('disabled') | upperCase }}
          </vs-chip>
        </vs-td>
        <vs-td>
          <div>
            <action-icon
              icon="FilePlusIcon"
              :tooltip="$t('add')"
              @click="editItem(data[i])"
            />
            <action-icon
              icon="ArrowRightCircleIcon"
              :tooltip="$t('details')"
              @click="details(data[i])"
              v-if="data[i].documentation_id != null"
            />
          </div>
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
    
    <script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ColorIcon from '@/views/qb-components/ColorIcon'
import mixins from '@/mixins'
import ThSort from '@/views/components/ThSort'

import { BASE_URL } from '@/urls.js'


export default {
  components: {
    ActionIcon,
    ColorIcon,
    ThSort,
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    editItem: function (item) {
      this.$emit('edit',item)
    },
    handleClickSort: function (e) {
      this.$emit('sort', e)
    },
    infiniteHandler: function (isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search: function () {
      this.$emit('search', this.text)
    },
    details: function (item) {
      this.$emit('details',item.documentation_id)
    },
    downloadDocuments: function (id){
      window.open(BASE_URL + "/internal_api/zipFiles/PFcIhK-FuZKoNtXF6-0g5QhoA-vL/"+id);
    }
  },
  mixins: [mixins],
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
    
    <style>
</style>
    